class EmojiUtils {
  static convertEmojiCodeReceive(code: string): string | null {
    try {
      const arrayCodeConverted = code.split('-');
      const arrayNumberCodes = arrayCodeConverted.map((code: string) => Number(code));

      return String.fromCodePoint(...arrayNumberCodes);
    } catch (error) {
      return null;
    }
  }

  static convertEmojiCodeSend(code: string) {
    const existMultipleCode = code.indexOf('-') !== -1;
    const codeWithHyphen = code.replace(/-/g, '-0x');

    if (code === '2764-fe0f') {
      return `0x${code.replace(/-/g, '-0x')}`;
    }

    if (existMultipleCode) {
      return `0x${codeWithHyphen}-0xFE0F`;
    } else {
      return `0x${code}-0xFE0F`;
    }
  }

  static getNativeFromUnified(code: string): string | null {
    try {
      return EmojiUtils.convertEmojiCodeReceive(EmojiUtils.convertEmojiCodeSend(code));
    } catch (error) {
      return null;
    }
  }
}

export default EmojiUtils;
